import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MdbNotificationModule } from 'src/lib/mdb5-adapted/public-api';
import { NotificationComponent } from './notification.component';
import { NotificationService } from './notification.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MdbNotificationModule,
    NotificationComponent
  ],
  providers:[NotificationService],
  exports: [NotificationComponent]
})
export class NotificationModule { }
